export default __webpack_public_path__ + "static/media/823.89e68374.gif";